<template>
  <select
    id="vue_stay_id"
    v-model="currentStay"
    aria-label="Stay"
    class="form-group select optional form-control"
    @change="emitStay()"
  >
    <option
      v-for="stay in activeStays"
      :key="stay.id"
      :value="stay"
    >
      {{ stay.room_type_translated }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    selectedStay: {
      default: {},
      required: true
    },

    // eslint-disable-next-line vue/require-prop-types
    stays: {
      default: [],
      required: true
    },

    packageQty: {
      default: 1,
      type: Number
    }
  },

  data() {
    return {
      currentStay: null
    }
  },

  computed: {
    activeStays() {
      return this.stays.filter(stay => stay.active == true && stay.inventory_on_site >= this.packageQty / stay.capacity)
    }
  },

  watch: {
    stays() {
      this.currentStay = this.stays[0]
      this.emitStay()
    }
  },


  created() {
    this.currentStay = this.stays[0]
    console.log(this.currentStay)
    this.emitStay()
  },

  methods: {
    emitStay() {
      this.$emit('stay-change', this.currentStay)
    }
  },
}
</script>
